import { useEffect, useState } from "react";
import useApi from "./useApi";

interface SalesforceConfig {
  id: number;
  displayName: string;
  instanceUrl?: string;
  enabled: boolean;
}

export default function useSalesforceConfigs() {
  const [items, setItems] = useState<SalesforceConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      try {
        const resp = await api.messaging.get("Salesforce/Integrations/Configs");
        const data = await resp.json();
        setItems(Array.isArray(data) ? data : []);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }
    fetchConfigs();
  }, [api.messaging]);

  return { items, loading };
}
